<template>
	<div class="weekWrap">
		<div class="rowHead">
			<div class="dayNameHead">Day</div>
			<div class="dayInfoHead">{{ weekTitle }}</div>
		</div>

		<row-day
				v-for="(item, index) in weeks"
				:key="item.date"
				:index="index"
				:item="item"
				:isIconBtn="isIconBtn"
				@updateEventIconBtn="onEventIconBtn($event, item)"
		></row-day>
	</div>
</template>

<script>
import RowDay from "@/pages/Account/Tabs/RowDay/RowDay.vue";

export default {
	name: "WeekWrap",
	components: {
		RowDay
	},
	props: {
		weekTitle: String,
		weeks: {
			type: Array,
			default: () => [] // Значение по умолчанию
		},
		isIconBtn: Boolean,
	},
	methods: {
		onEventIconBtn(key, item) {
			this.$emit('updateEventIconBtn', { key, item });
		},
	},
};
</script>

<style lang="scss">
	@import "WeekWrap";
</style>
